module.exports = {
    tag: 'unbalanced',
    quality: 0,
    dexterity: -2,
    damageMod: -0.1
};